/**
 * Route helper for vue
 *
 * Usage: route(name, parameter);
 * Example: route('tenants.users.show', {'user', 385});
 */

export default (name, parameter) => {
    var route = window.routes.filter(route => {
        return route.name == name;
    })[0];

    // Throw a not found error message.
    if (!route) {
        throw('Route "' + name + '" not found!');
    }

    if (route !== undefined) {
        // If there is only 1 parameter and it is an integer, we do this one here
         if(typeof parameter === "number") {
            if ((route.uri.match(/\{/g) || []).length == 1) {
                return route.uri.replace(/\{.*\}/, parameter);
            } else {
                throw('Route ' + route.uri + ' expects more than 1 parameter, only 1 parameter given!');
            }
        }

        // We have to handle it with a temp var, so to not override the global route.uri
        var temp = route.uri;
        for (var index in parameter) {
            temp = temp.replace('{' + index + '}', parameter[index]);
        }
        return temp;
    }
};